import { useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useRef } from 'react';

import type { SubscriptionsAnalyticsProperties } from '@calm-web/api-sdk/lib/atlas-subscriptions-api';

import { usePageName } from '@/context/PageNameProvider';
import getSubscriptionsWebAnalyticsProperties from '@/utils/analytics/getSubscriptionsAnalyticsProperties';
import { getCookie } from '@/utils/cookies';

export default function useSubscriptionsAnalyticsProperties() {
	const ref = useRef<SubscriptionsAnalyticsProperties>(undefined);

	const pageName = usePageName();
	const searchParams = useSearchParams();

	useEffect(() => {
		ref.current = {
			appsflyerId: getCookie('afUserId'),
			googleClickId: searchParams?.get('gclid') ?? undefined,
			metaBrowserId: getCookie('_fbp'),
			metaClickId: searchParams?.get('fbclid') ?? getCookie('_fbc'),
			upsellLocation: 'Web',
			webProperties: getSubscriptionsWebAnalyticsProperties(pageName),
		};
	}, [pageName, searchParams]);

	const getSubscriptionsAnalyticsProperties = useCallback(() => ref.current, []);

	return { getSubscriptionsAnalyticsProperties };
}
